import api from './api';

function csvRequestConfig(params = {}) {
    return {
        params: { ...params, format: 'csv' },
        responseType: 'blob',
    };
}

export const reportsService = {
    minMaxRestock: (params = {}) => api.get('/reports/min-max-restock', { params }),
    minMaxRestockCsv: (params = {}) => api.get('/reports/min-max-restock', csvRequestConfig(params)),

    annualStock: (params = {}) => api.get('/reports/annual-stock', { params }),
    annualStockCsv: (params = {}) => api.get('/reports/annual-stock', csvRequestConfig(params)),

    projectedStock: (params = {}) => api.get('/reports/projected-stock', { params }),
    projectedStockCsv: (params = {}) => api.get('/reports/projected-stock', csvRequestConfig(params)),

    stockMovements: (params = {}) => api.get('/reports/stock-movements', { params }),
    stockMovementsCsv: (params = {}) => api.get('/reports/stock-movements', csvRequestConfig(params)),

    stockMovementDailyExtract: (params = {}) =>
        api.get('/reports/stock-movements/daily-extract', { params }),

    productionOrderReports: (params = {}) => api.get('/reports/production-order-reports', { params }),
    productionOrderReportsCsv: (params = {}) =>
        api.get('/reports/production-order-reports', csvRequestConfig(params)),

    saleFulfillment: (params = {}) => api.get('/reports/sale-fulfillment', { params }),
    saleFulfillmentCsv: (params = {}) => api.get('/reports/sale-fulfillment', csvRequestConfig(params)),

    saleBacklog: (params = {}) => api.get('/reports/sale-backlog', { params }),
    saleBacklogCsv: (params = {}) => api.get('/reports/sale-backlog', csvRequestConfig(params)),
};
